import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const StepperButtons = (
  step,
  classes,
  selectedPickupsList,
  driverRecommendedPickupSelected,
  unassignPickupSelected,
  pickupUpdateInProgress,
  notifyInProgress,
  optymize,
  acceptNotify,
  onClose,
  unassignPickupDropdownError
) => {
  let isAcceptAndNotifyDisabled = false;
  if (step === 1) {
    isAcceptAndNotifyDisabled = (
      driverRecommendedPickupSelected.length + unassignPickupSelected.length === 0 ||
      Object.values(unassignPickupDropdownError).filter(Boolean).length
    )
  }
  switch (step) {
    case 0:
      return (
        <Button
          variant="contained"
          disabled={selectedPickupsList.length === 0}
          color="primary"
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          id="optymizebtn"
          onClick={optymize}
        >
          {pickupUpdateInProgress ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            "Optymize"
          )}
        </Button>
      );
    case 1:
      return (
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          disabled={isAcceptAndNotifyDisabled}
          onClick={acceptNotify}
        >
          {notifyInProgress ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            "Accept and Notify Drivers"
          )}
        </Button>
      );
    case 2:
      return (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClose}
        >
          Done
        </Button>
      );
  }
};

export default StepperButtons;
